var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHmZones({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M87.3178 29.2813L49.2803 7.32032C42.2778 3.27742 33.3237 5.67666 29.2808 12.6792L7.31985 50.7167C3.27694 57.7192 5.67618 66.6733 12.6787 70.7162L50.7162 92.6771C57.7187 96.72 66.6728 94.3208 70.7157 87.3183L92.6767 49.2808C96.7196 42.2783 94.3203 33.3242 87.3178 29.2813Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M92.6794 50.7167L70.7185 12.6792C66.6756 5.67666 57.7215 3.27742 50.719 7.32032L12.6815 29.2813C5.67894 33.3242 3.2797 42.2783 7.3226 49.2808L29.2836 87.3183C33.3265 94.3208 42.2806 96.72 49.2831 92.6771L87.3206 70.7162C94.3231 66.6733 96.7223 57.7192 92.6794 50.7167Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M71.9596 13.3972H28.0377C19.9519 13.3972 13.397 19.9521 13.397 28.0379V71.9598C13.397 80.0456 19.9519 86.6004 28.0377 86.6004H71.9596C80.0454 86.6004 86.6003 80.0456 86.6003 71.9598V28.0379C86.6003 19.9521 80.0454 13.3972 71.9596 13.3972Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7684 23.7917V53.7407H55.7378V23.7917H52.7072V53.7407H46.646V23.7917H43.6153V53.7407H40.5847V23.7917H37.5541V75.971H40.5847V62.8325H43.6153V75.971H46.646V62.8325H52.7072V75.971H55.7378V59.8019H40.5847V56.7713H58.7684V75.971H61.799V23.7917H58.7684Z",
    fill: "#6E6E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHmZones);
export default __webpack_public_path__ + "static/media/HMZones.836de3f0dc39396e9489f0e2914b296d.svg";
export { ForwardRef as ReactComponent };